import React from 'react';
import {
  HOME_PAGE,
  WEBSITE_PAGE,
  PRIVACY_POLICY_PAGE,
  SETTINGS_PAGE,
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
  SUBTITLES_HEIGHT,
  SUBTITLES_WIDTH
} from "./constants";
import {isElectron} from './utils';

// Decorators
import { withCustomer } from './containers/withCustomer';
import { withProfile } from './containers/withProfile';

// Components
import LoginOrSignUp from "./components/LoginOrSignUp";
import PublicWebsite from "./components/PublicWebsite";
import PrivateHome from "./components/PrivateHome";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PrivateSettings from "./components/PrivateSettings";

// React router
import { Route as _Route, Switch } from 'react-router-dom'

// Authentication
import auth from './auth';

// Action creators
import {
  handleAuthentication,
  handleAuthenticationError
} from './actions';


export default function createRoutes(store) {

  const Route = onEnter(resizeWindow)(_Route);

  function isAuthenticated(accessToken, expiresAt) {
    if (accessToken && expiresAt) {
      return new Date().getTime() < expiresAt * 1000;
    } else {
      return false
    }
  }

  function parseHash() {

    // If there is no hash, do nothing.
    if (!window.location.hash) return;

    auth.parseHash({hash: window.location.hash},
      (error, authResult) => {
        if (error) {
          console.log({error_0: error});
          store.dispatch(handleAuthenticationError(
            {message: "Authentication Error"}));
        } else if (authResult) {
          store.dispatch(handleAuthentication(authResult));
        } else {
          store.dispatch(handleAuthenticationError(
            {message: "Authentication Error"}));
        }
      });
  }

  function resizeWindow() {
    if (!isElectron()) return;

    const authenticated = isAuthenticated(
      store.getState().accessToken,
      store.getState().expiresAt
    );
    const onHomePage = window.location.pathname === HOME_PAGE;
    if (authenticated && onHomePage) {
      window.resizeTo(SUBTITLES_WIDTH, SUBTITLES_HEIGHT);
    } else {
      window.resizeTo(DEFAULT_WIDTH, DEFAULT_HEIGHT);
    }
  }

  const PrivateRoute = ({component: Component, ...rest}) => (
    <Route
      {...rest}
      render={
        props => isAuthenticated(
          store.getState().accessToken,
          store.getState().expiresAt
        ) ? <Component {...props}/> : <LoginOrSignUp/>
      }
    />
  );

  function onEnter(onEnterFunction) {
    return (ComposedComponent) => {

      class OnEnterWrapper extends React.Component {

        componentWillMount() {
          onEnterFunction()
        }

        render() {
          return <ComposedComponent {...this.props}/>
        }
      }

      return OnEnterWrapper;
    };
  }

  // If there is a Route with "path === redirectUri"
  // (where "redirectUri" is the auth0 post-auth redirect URI)
  // then the hash should be parsed before this Route component mounts.
  const ParsedPrivateRoute = onEnter(parseHash)(PrivateRoute);

  return <Switch>
    <Route
      path={PRIVACY_POLICY_PAGE}
      component={PrivacyPolicy}
    />
    <PrivateRoute
      path={SETTINGS_PAGE}
      component={withProfile(withCustomer(PrivateSettings))}
    />
    <ParsedPrivateRoute
      path={HOME_PAGE}
      component={withProfile(withCustomer(PrivateHome))}
    />
    <Route path={WEBSITE_PAGE} component={PublicWebsite}/>
    {/* catch all */}
    <Route to={WEBSITE_PAGE}/>
  </Switch>;
}



// WEBPACK FOOTER //
// ./src/routes.js